import { render, staticRenderFns } from "./list-page.vue?vue&type=template&id=94c8bc8c&"
import script from "./list-page.vue?vue&type=script&lang=ts&"
export * from "./list-page.vue?vue&type=script&lang=ts&"
import style0 from "./list-page.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports